import { Config } from '@/bootstrap/config';

const THIRTY_DAYS_MS = 30 * 24 * 60 * 60 * 1000;

export function getNibTokenExpiryStatus(config: Config): {
    expired: boolean;
    expiringSoon: boolean;
    expiryDate: Date | null;
} {
    if (!config.nib_token_expiry)
        return { expired: false, expiringSoon: false, expiryDate: null };
    const expiry = new Date(config.nib_token_expiry);
    if (isNaN(expiry.getTime()))
        return { expired: false, expiringSoon: false, expiryDate: null };
    const now = new Date();
    const timeUntilExpiry = expiry.getTime() - now.getTime();
    return {
        expired: timeUntilExpiry <= 0,
        expiringSoon: timeUntilExpiry > 0 && timeUntilExpiry <= THIRTY_DAYS_MS,
        expiryDate: expiry,
    };
}

export function getNibTokenExpiryWarningMessage(config: Config): string | null {
    const { expired, expiringSoon, expiryDate } = getNibTokenExpiryStatus(config);
    if (!expiryDate || (!expired && !expiringSoon)) return null;

    return expired
        ? 'NiB-token har utløpt! Flyfoto vil ikke fungere. Se docs/nib-token.md.'
        : `NiB-token utløper ${expiryDate.toLocaleDateString('nb-no')}. Se docs/nib-token.md.`;
}
